<template>
    <div>
        <loading v-if="!loaded" />
        <div v-if="loaded">
            <el-tabs v-model="tabName">
                <el-tab-pane label="តារាងសារជូនដំណឹង" name="first"></el-tab-pane>
                <el-tab-pane label="តារាងកាលវិភាគផ្ញើសារជូនដំណឹង" name="second"></el-tab-pane>
                <el-tab-pane label="បង្កើតសារជូនដំណឹងថ្មី" name="third"></el-tab-pane>
                <el-tab-pane label="បង្កើតកាលវិភាគសារជូនដំណឹងថ្មី" name="forth"></el-tab-pane>
            </el-tabs>

            <div v-if="tabName == 'first'">
                <md-table v-if="notification_list.length > 0">
                    <md-table-row>
                        <md-table-head>ល.រ.</md-table-head>
                        <md-table-head>ចំណងជើង</md-table-head>
                        <md-table-head>សារជូនដំណឹង</md-table-head>
                        <md-table-head>ថ្ងៃបង្កើត</md-table-head>
                        <md-table-head>សកម្មភាព</md-table-head>
                    </md-table-row>

                    <md-table-row v-for="(notification, index) in notification_list">
                        <md-table-cell>{{ index + 1}}</md-table-cell>
                        <md-table-cell>{{ notification.title }}</md-table-cell>
                        <md-table-cell>{{ notification.body }}</md-table-cell>
                        <md-table-cell>{{ config.datelify(notification.created_date) }}</md-table-cell>
                        <md-table-cell>
                            <md-button class="md-just-icon md-simple md-danger"
                                @click="deleteNotification(notification.hash_id)">
                                <md-icon>delete</md-icon>
                                <md-tooltip md-direction="top">លុបចេញ</md-tooltip>
                            </md-button>
                        </md-table-cell>
                    </md-table-row>
                </md-table>
                <h5 class="text-center" v-if="notification_list.length == 0 && loaded == true">មិនមានសារជូនដំណឹង</h5>
            </div>
            <div v-if="tabName == 'second'">
                <md-table v-if="notification_schedule_list.length > 0">
                    <md-table-row>
                        <md-table-head>ល.រ.</md-table-head>
                        <md-table-head>ចំណងជើង</md-table-head>
                        <md-table-head>សារជូនដំណឹង</md-table-head>
                        <md-table-head>ម៉ោងផ្ញើសារ</md-table-head>
                        <md-table-head>ថ្ងៃបង្កើត</md-table-head>
                        <md-table-head>សកម្មភាព</md-table-head>
                    </md-table-row>

                    <md-table-row v-for="(notification, index) in notification_schedule_list">
                        <md-table-cell>{{ index + 1}}</md-table-cell>
                        <md-table-cell>{{ notification.title }}</md-table-cell>
                        <md-table-cell>{{ notification.body }}</md-table-cell>
                        <md-table-cell>{{ config.get_time_from_date_view(notification.time_utc) }}</md-table-cell>
                        <md-table-cell>{{ config.datelify(notification.created_date) }}</md-table-cell>
                        <md-table-cell>
                            <md-button class="md-just-icon md-simple md-danger"
                                @click="deleteNotificationSchedule(notification.hash_id)">
                                <md-icon>delete</md-icon>
                                <md-tooltip md-direction="top">លុបចេញ</md-tooltip>
                            </md-button>
                        </md-table-cell>
                    </md-table-row>
                </md-table>
                <h5 class="text-center" v-if="notification_schedule_list.length == 0 && loaded == true">
                    មិនមានសារជូនដំណឹង</h5>
            </div>

            <div v-if="tabName == 'third'">
                <div class="md-layout">
                    <div class="md-layout-item md-small-size-100 md-size-100">
                        <md-field>
                            <label>ចំណងជើង</label>
                            <md-input type="text" v-model="notification.title"></md-input>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-100">
                        <md-field>
                            <label>សារជូនដំណឹង</label>
                            <md-input type="text" v-model="notification.body"></md-input>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-size-100 text-right">
                        <md-button class="md-raised md-primary" @click="postDialogActive = true">ជូនដំណឹងឥឡូវ</md-button>
                    </div>
                </div>
            </div>
            <div v-if="tabName == 'forth'">
                <div class="md-layout">
                    <div class="md-layout-item md-small-size-100 md-size-33">
                        <md-field>
                            <label>ចំណងជើង</label>
                            <md-input type="text" v-model="notification_schedule.title"></md-input>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-33">
                        <md-field>
                            <label>សារជូនដំណឹង</label>
                            <md-input type="text" v-model="notification_schedule.body"></md-input>
                        </md-field>
                    </div>
                    <div class="md-layout-item md-small-size-100 md-size-33">
                        <md-field>
                            <label>ម៉ោងផ្ញើសារ</label>
                            <md-input type="text" v-model="notification_schedule.time" style="display:none" />
                            <datetime type="time" v-model="notification_schedule.time"></datetime>
                        </md-field>
                    </div>

                    <div class="md-layout-item md-size-100 text-right">
                        <md-button class="md-raised md-primary"
                            @click="postScheduleDialogActive = true">បង្កើតថ្មី</md-button>
                    </div>
                </div>
            </div>
        </div>

        <md-dialog-confirm :md-active.sync="postDialogActive" :md-title="'តើអ្នកពិតជាចង់ជូនដំណឹងមែនឬ​ ?'"
            md-confirm-text="យល់ព្រម" md-cancel-text="បោះបង់" @md-cancel="cancel" @md-confirm="post" />
        <md-dialog-confirm :md-active.sync="postScheduleDialogActive"
            :md-title="'តើអ្នកពិតជាចង់បង្កើតកាលវិភាគជូនដំណឹងមែនឬ​ ?'" md-confirm-text="យល់ព្រម" md-cancel-text="បោះបង់"
            @md-cancel="cancel" @md-confirm="postSchedule" />
        <md-dialog-confirm :md-active.sync="deleteDialog" md-title="តើអ្នកពិតជាចង់លុបពិតមែនទេ ?" md-confirm-text="លុប"
            md-cancel-text="បោះបង់" @md-cancel="cancel" @md-confirm="deleteNotification" />
        <md-dialog-confirm :md-active.sync="deleteScheduleDialog" md-title="តើអ្នកពិតជាចង់លុបពិតមែនទេ ?"
            md-confirm-text="លុប" md-cancel-text="បោះបង់" @md-cancel="cancel"
            @md-confirm="deleteNotificationSchedule" />
    </div>
</template>

<script>
    import { Datetime } from 'vue-datetime';
    export default {
        components: {
            datetime: Datetime
        },
        created() {
            this.searchHandler();
            this.searchScheduleHandler();
        },
        data() {
            return {
                tabName: 'first',
                loaded: false,
                loadMore: false,
                notification_list: [],
                notification: {
                    title: "",
                    body: ""
                },
                notification_schedule_list: [],
                notification_schedule: {
                    title: "",
                    body: "",
                    time: ""
                },
                search: {
                    text: ""
                },
                postDialogActive: false,
                postScheduleDialogActive: false,
                deleteDialog: false,
                deleteScheduleDialog: false,
                deleteHash: ""
            }
        },
        methods: {
            searchHandler(more = false) {
                let size = 50;
                this.$http.post(this.config.api + "/admin/notification/search", {
                    text: this.search.text,
                    size: size,
                    offset: more ? this.notification_list.length : 0
                }).then(data => {
                    this.loaded = true;
                    if (data.body.data.length == size) this.loadMore = true;
                    else this.loadMore = false;
                    this.notification_list = more ? this.notification_list.concat(data.body.data) : data.body.data;
                })
            },
            searchScheduleHandler(more = false) {
                let size = 50;
                this.$http.post(this.config.api + "/admin/notification/search_schedule", {
                    size: size,
                    offset: more ? this.notification_schedule_list.length : 0
                }).then(data => {
                    this.loaded = true;
                    this.notification_schedule_list = more ? this.notification_schedule_list.concat(data.body.data) : data.body.data;
                })
            },
            cancel() {
                this.postDialogActive = false;
                this.postScheduleDialogActive = false;
                this.deleteDialog = false;
                this.deleteScheduleDialog = false;
                this.deleteHash = "";
            },

            post() {

                if (String(this.notification.title).length < 3 || String(this.notification.body).length < 3) {
                    this.$notification.notify({ message: "សូមបំពេញព័ត៌មានបន្ថែម", icon: 'info', type: 'warning' });
                    return false;
                }

                this.$http.post(this.config.api + "/admin/notification/post", {
                    title: this.notification.title,
                    body: this.notification.body,
                }).then(res => {
                    if (res.body.status == 'success') {
                        this.$notification.notify({ message: "អ្នកបានផ្ញើសារជូនដំណឹងដោយជោគជ័យ។", icon: 'check_circle', type: 'success' });
                        this.searchHandler();
                        this.tabName = 'first';
                        this.notification.title = "";
                        this.notification.body = "";
                    }
                });
            },
            postSchedule() {

                if (String(this.notification_schedule.title).length < 3 || String(this.notification_schedule.body).length < 3 || String(this.notification_schedule.time).length < 3) {
                    this.$notification.notify({ message: "សូមបំពេញព័ត៌មានបន្ថែម", icon: 'info', type: 'warning' });
                    return false;
                }

                this.$http.post(this.config.api + "/admin/notification/post_schedule", {
                    title: this.notification_schedule.title,
                    body: this.notification_schedule.body,
                    time: this.notification_schedule.time
                }).then(res => {
                    if (res.body.status == 'success') {
                        this.$notification.notify({ message: "អ្នកបានបង្កើតកាលវិភាគផ្ញើសារជូនដំណឹងដោយជោគជ័យ។", icon: 'check_circle', type: 'success' });
                        this.searchScheduleHandler();
                        this.tabName = 'second';
                        this.notification_schedule.title = "";
                        this.notification_schedule.body = "";
                        this.notification_schedule.time = "";
                    }
                });
            },
            deleteNotification(hash_id) {
                if (this.deleteHash == "") {
                    this.deleteHash = hash_id;
                    this.deleteDialog = true;
                    return false;
                }
                this.$http.post(this.config.api + "/admin/notification/delete", {
                    hash_id: this.deleteHash,
                }).then(res => {
                    this.searchHandler();
                    this.cancel();
                })
            },
            deleteNotificationSchedule(hash_id) {
                if (this.deleteHash == "") {
                    this.deleteHash = hash_id;
                    this.deleteScheduleDialog = true;
                    return false;
                }
                this.$http.post(this.config.api + "/admin/notification/delete_schedule", {
                    hash_id: this.deleteHash,
                }).then(res => {
                    this.searchScheduleHandler();
                    this.cancel();
                })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/Notifications/View.vue